import { ComponentType } from 'react'
import { Provider } from 'react-redux'

import store from '../redux/store'

export default (WrappedComponent: ComponentType) => {
  const Component = ({ ...props }) => (
    <Provider store={store}>
      <WrappedComponent {...props} />
    </Provider>
  )

  return Component
}
